export const getIsScoreEqual = (homeScore?: string, awayScore?: string) => {
  const isNonEmptyString = (value: unknown) => typeof value === "string" && value.length > 0;
  return isNonEmptyString(homeScore) && isNonEmptyString(awayScore) && homeScore === awayScore;
};
